import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import CartItemsCount from '../../../js/entries/shop-product/components/cart-items-count';
import GaTracking from '../../../js/core/components/ga-tracking';
import Checkout from './views/Checkout';
import createCheckoutApi from './api/api';
import SelectField from './components/SelectField';
import { isOnePageCheckoutEnabled } from './utils/eligibility';
import createPurchaseEvent from './utils/createPurchaseEvent';
import useLatestRef from '../../hooks/useLatestRef';
export const currentView = () => window.matchMedia('(min-width: 992px)').matches ? 'desktop' : 'mobile';
export const currentPdpUrl = () => `${window.location.pathname}${window.location.search}`;
export const currentCheckoutContext = () => ({
    view: currentView(),
    pdpUrl: currentPdpUrl(),
    abOnepageTest: document.body.classList.contains('ab-onepage-test'),
});
export default function LegacyApp({ config }) {
    const [startRequest, setStartRequest] = useState(null);
    const { t } = useTranslation();
    const translate = useCallback((key, values) => t(key, values), [t]);
    const latestTranslate = useLatestRef(translate);
    const updateCartQuantity = useCallback((quantity) => CartItemsCount.set(quantity), []);
    const api = useMemo(() => createCheckoutApi({
        baseUrl: config.baseUrl,
        csrf: config.csrf,
        context: currentCheckoutContext,
        errorMessage: () => latestTranslate.current('one_page_checkout.error'),
    }), [config.baseUrl, config.csrf, latestTranslate]);
    useEffect(() => {
        const onStart = (event) => {
            setStartRequest(previous => ({
                id: (previous?.id ?? 0) + 1,
                variantCode: event.detail,
                automatic: false,
            }));
        };
        window.addEventListener('one-page-checkout:start', onStart);
        if (new URLSearchParams(window.location.search).get('onepage') === '2' &&
            isOnePageCheckoutEnabled(config.setting, currentView(), '2')) {
            const variantCode = document.querySelector('.js__single-product-color-select:checked')?.value || '';
            setStartRequest(previous => ({ id: (previous?.id ?? 0) + 1, variantCode, automatic: true }));
        }
        return () => window.removeEventListener('one-page-checkout:start', onStart);
    }, [config.setting]);
    return (_jsx(Checkout, { content: config, api: api, startRequest: startRequest, translate: translate, SelectField: SelectField, agreementContent: parse(t('one_page_checkout.agreement', { linkClass: 'link-underlined' })), onCartQuantityChange: updateCartQuantity, onPurchase: (_snapshot, result) => GaTracking.pushDataLayer(createPurchaseEvent(result)), onSuccessClose: () => window.location.reload(), navigate: url => window.location.assign(url) }));
}
